module.exports = __webpack_public_path__ + "static/media/Lateral_Moderate_Z1.f11b7f8c.png";